import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, MapPin, ShieldCheck, Building2 } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden" data-id="element-72">
      {/* Background Image with Parallax feel */}
      <div className="absolute inset-0 z-0" data-id="element-73">
        <img src="https://cdn.magicpatterns.com/uploads/9rL5ksozc2X7pMwmcFGh2z/bailey-alexander-PE4pFgcYzoQ-unsplash.jpg" alt="Bright, freshly cleaned modern open-concept living space" className="w-full h-full object-cover object-center" data-id="element-74" />
        {/* 1. Base neutral scrim, dark and moody for strong text contrast */}
        <div className="absolute inset-0" style={{
        backgroundColor: 'rgba(14, 42, 54, 0.68)'
      }} data-id="element-75" />
        {/* 2. Very subtle brand tint so it does not lighten the photo back up */}
        <div className="absolute inset-0 brand-gradient opacity-[0.15] mix-blend-soft-light" data-id="element-76" />
        {/* 3. Center-weighted dark radial so the area behind the text is darkest */}
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse 70% 60% at center, rgba(14,42,54,0.6) 0%, rgba(14,42,54,0) 75%)'
      }} data-id="element-77" />
        {/* 4. Bottom-up dark gradient keeps the buttons on a darker zone */}
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to top, rgba(14,42,54,0.75) 0%, rgba(14,42,54,0) 55%)'
      }} data-id="element-78" />
      </div>

      <div className="container relative z-10 mx-auto px-4" data-id="element-79">
        <div className="max-w-3xl mx-auto text-center" data-id="element-80">
          <span className="inline-block py-1 px-3 rounded-full bg-black/40 backdrop-blur-sm text-white text-sm font-semibold tracking-wider uppercase mb-6" data-id="element-81">
            Clean · Fresh · Reliable
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white mb-6 leading-tight" style={{
          textShadow: '0 2px 12px rgba(0,0,0,0.4)'
        }} data-id="element-82">
            Come Home to Spotless.
          </h1>

          <p className="text-lg md:text-xl text-white mb-10 font-body leading-relaxed max-w-2xl mx-auto" style={{
          textShadow: '0 2px 12px rgba(0,0,0,0.4)'
        }} data-id="element-83">
            Far East El Paso's trusted residential and commercial cleaning team.
            We show up on time, we clean it right, and you walk into a home that
            feels brand new.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-84">
            <Button className="w-full sm:w-auto h-14 px-8 rounded-full brand-gradient text-white font-semibold text-lg border-0 hover:opacity-90 shadow-lg" data-id="element-85">
              Get Your Free Quote
            </Button>
            <Button variant="outline" className="w-full sm:w-auto h-14 px-8 rounded-full bg-transparent border-2 border-white text-white font-semibold text-lg hover:bg-white hover:text-brand-navy transition-colors" data-id="element-86">
              View Services
            </Button>
          </div>
        </div>
      </div>

      {/* Trust Strip */}
      <div className="absolute bottom-0 left-0 w-full bg-white/10 backdrop-blur-md border-t border-white/20 py-4" data-id="element-87">
        <div className="container mx-auto px-4" data-id="element-88">
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-white text-sm md:text-base font-medium" data-id="element-89">
            <div className="flex items-center" data-id="element-90">
              <CheckCircle2 className="w-5 h-5 mr-2 text-brand-green" data-id="element-91" />
              Bilingual Team
            </div>
            <div className="flex items-center" data-id="element-92">
              <MapPin className="w-5 h-5 mr-2 text-brand-green" data-id="element-93" />
              Locally Owned
            </div>
            <div className="flex items-center" data-id="element-94">
              <ShieldCheck className="w-5 h-5 mr-2 text-brand-green" data-id="element-95" />
              Satisfaction Guaranteed
            </div>
            <div className="flex items-center" data-id="element-96">
              <Building2 className="w-5 h-5 mr-2 text-brand-green" data-id="element-97" />
              Residential & Commercial
            </div>
          </div>
        </div>
      </div>
    </section>;
}